export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/ranking/icon-help-64177678b638fc76cf46a87ce9363ac0.svg";